import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { DataProvider } from "./ContextApi/ContextProvider";
import AppRoutes from "./AppRotes";

function App() {
  return (
    <Router>
      <DataProvider>
        <AppRoutes />
      </DataProvider>
    </Router>
  );
}

export default App;
